/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import DocumentationModal from 'docs/components/apis/DocumentationModal.vue';

/**
 * This component is used to display a tabbed view of some definition,
 * being it a parameter, a model, or a definition set.
 *
 * @vue-prop {Object} schema the schema to display
 * @vue-prop {Object} [definitions] the set of models definitions
 * @vue-prop {Object} [headers] the set of headers definitions
 *
 * @vue-data {String} example the schema resulting example string
 * @vue-data {Object[]} model a list of model properties details
 * @vue-data {String} [description] an optional generic description of the schema
 * @vue-data {Boolean} showExample the model/example tab switch
 *
 * @category docs.components.apis
 * @exports Schema
 * @component
 */
const __vue_script__ = {
    name: 'Schema',

    props: {
        schema: {
            type: Object,
            default: () => {}
        },

        definitions: {
            type: Object,
            default: () => {}
        },

        headers: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            initialized: false,
            example: '',
            model: [],
            description: null,
            showDetails: false,
            showExample: false,
            requirements: [],
            parsedHeaders: [],
            showHeadersExample: false,
            headersExample: ''
        };
    },

    watch: {
        showDetails(value) {
            if (value && !this.initialized) {
                this.init();
            }
        }
    },

    created() {
        this.description = this.schema?.description;
    },

    methods: {
        /**
         * Initialize the component
         */
        init() {
            const { properties, model } = this.$services.apiDoc.parseSchema(this.schema, this.definitions);
            const { headers, headersExample } = this.$services.apiDoc.parseHeaders(this.headers);

            this.parsedHeaders = headers;
            this.headersExample = JSON.stringify(headersExample, null, 2) || '';
            if (this.headersExample === '{}') {
                this.headersExample = '';
            }

            this.example = JSON.stringify(properties, null, 2) || '';
            if (this.example === '{}') {
                this.example = '';
            }

            this.model = model || [];
            this.requirements = this.schema?.required || this.requirements;
            this.initialized = true;
        },

        /**
         * Checks if a field is required
         *
         * @param {String} field the name of the field to check
         *
         * @returns {Boolean} whether the field is required or not
         */
        required(field) {
            return this.requirements.includes(field);
        },

        /**
         * The action to execute when clicking on on see the definitions documentation
         */
        showDocumentation() {
            const name = 'Selector';
            const definition = this.definitions[name];

            this.$modal.show(DocumentationModal,
                { name, definition },
                {
                    classes: 'medium',
                    height: 'auto',
                    reset: true
                }
            );
        },
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"schema"},[(_vm.schema && (_vm.schema.properties || _vm.schema.$ref || (_vm.schema.items && _vm.schema.items.$ref)) || _vm.headers)?_c('a',{staticClass:"more has-action opposite small",on:{"click":function($event){_vm.showDetails = !_vm.showDetails}}},[_vm._v(_vm._s(_vm.$t(("api_docs.schema." + (_vm.showDetails ? 'less' : 'more')))))]):_vm._e(),_vm._t("default"),(_vm.description)?_c('vue-markdown',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))]):_vm._e(),(_vm.showDetails && (_vm.example.length || _vm.model.length))?_c('section',{staticClass:"properties"},[(_vm.example.length && _vm.model.length)?_c('ul',{staticClass:"nav"},[_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.length),expression:"model.length"}],staticClass:"nav-item",class:{active: !_vm.showExample}},[_c('a',{staticClass:"has-action",on:{"click":function($event){_vm.showExample = false}}},[_vm._v(_vm._s(_vm.$t('api_docs.schema.model')))])]),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.example.length),expression:"example.length"}],staticClass:"nav-item",class:{active: _vm.showExample}},[_c('a',{staticClass:"has-action",on:{"click":function($event){_vm.showExample = true}}},[_vm._v(_vm._s(_vm.$t('api_docs.schema.example_value')))])])]):_vm._e(),_c('div',{staticClass:"tabs"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showExample && _vm.model.length),expression:"!showExample && model.length"}],staticClass:"tab"},[_c('div',{staticClass:"table-wrapper"},[_c('table',{staticClass:"table-striped"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('api_docs.schema.prop')))]),_c('th',[_vm._v(_vm._s(_vm.$t('api_docs.schema.type')))]),_c('th',[_vm._v(_vm._s(_vm.$t('api_docs.schema.desc')))])])]),_c('tbody',_vm._l((_vm.model),function(property){return _c('tr',[_c('td',{staticClass:"code"},[_vm._v(_vm._s(property.name)),(_vm.required(property.name))?_c('span',{staticClass:"required"},[_vm._v(_vm._s(_vm.$t('api_docs.params.required')))]):_vm._e()]),_c('td',{staticClass:"code"},[_vm._v(_vm._s(property.type)),(property.enum)?_c('div',{staticClass:"enum"},[_c('small',[_vm._v("enum("+_vm._s(property.enum.join(', '))+")")])]):_vm._e()]),_c('td',[(property.$ref && property.$ref=='#/definitions/Selector')?_c('a',{staticClass:"doc has-action small",on:{"click":function($event){return _vm.showDocumentation()}}},[_vm._v(_vm._s(_vm.$t('api_docs.schema.see_documentation')))]):(property.schema)?_c('schema',{attrs:{"schema":property.schema,"definitions":_vm.definitions}}):_c('vue-markdown',{staticClass:"desc"},[_vm._v(_vm._s(property.description))])],1)])}),0)])])]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showExample && _vm.example.length),expression:"showExample && example.length"}],staticClass:"tab"},[_c('div',{directives:[{name:"code-highlight",rawName:"v-code-highlight"}],staticClass:"example"},[_vm._v(_vm._s(_vm.example))])])])]):_vm._e(),(_vm.showDetails && (_vm.headersExample.length || _vm.parsedHeaders.length))?_c('section',{staticClass:"properties"},[(_vm.headersExample.length || _vm.parsedHeaders.length)?_c('ul',{staticClass:"nav"},[_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.parsedHeaders.length),expression:"parsedHeaders.length"}],staticClass:"nav-item",class:{active: !_vm.showHeadersExample}},[_c('a',{staticClass:"has-action",on:{"click":function($event){_vm.showHeadersExample = false}}},[_vm._v(_vm._s('Headers'))])]),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.headersExample.length),expression:"headersExample.length"}],staticClass:"nav-item",class:{active: _vm.showHeadersExample}},[_c('a',{staticClass:"has-action",on:{"click":function($event){_vm.showHeadersExample = true}}},[_vm._v(_vm._s('Example value'))])])]):_vm._e(),_c('div',{staticClass:"tabs"}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showHeadersExample && _vm.parsedHeaders.length),expression:"!showHeadersExample && parsedHeaders.length"}],staticClass:"tab"},[_c('div',{staticClass:"table-wrapper"},[_c('table',{staticClass:"table-striped"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('api_docs.schema.prop')))]),_c('th',[_vm._v(_vm._s(_vm.$t('api_docs.schema.type')))]),_c('th',[_vm._v(_vm._s(_vm.$t('api_docs.schema.desc')))])])]),_c('tbody',_vm._l((_vm.parsedHeaders),function(property){return _c('tr',[_c('td',{staticClass:"code"},[_vm._v(_vm._s(property.name))]),_c('td',{staticClass:"code"},[_vm._v(_vm._s(property.type)),(property.enum)?_c('div',{staticClass:"enum"},[_c('small',[_vm._v("enum("+_vm._s(property.enum.join(', '))+")")])]):_vm._e()]),_c('td',[_vm._v(_vm._s(property.description))])])}),0)])])]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHeadersExample && _vm.headersExample.length),expression:"showHeadersExample && headersExample.length"}],staticClass:"tab"},[_c('div',{directives:[{name:"code-highlight",rawName:"v-code-highlight"}],staticClass:"example"},[_vm._v(_vm._s(_vm.headersExample))])])]):_vm._e()],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Schema.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__